// Reloj de la bandeja, inyectable. La cuenta regresiva y la encuesta periodica
// dependen del tiempo; en los tests se reemplaza por un reloj manual que se
// adelanta a mano, sin timers falsos ni esperas reales.
//
// El reloj solo sirve para mostrar y para decidir cuando volver a preguntar:
// el estado que manda es siempre el del servidor (`deadlineAt`).

export interface Clock {
  /** Milisegundos desde epoch. */
  now(): number;
  /** Llama a `fn` cada `ms`; devuelve la funcion que lo detiene. */
  every(ms: number, fn: () => void): () => void;
}

export const systemClock: Clock = {
  now: () => Date.now(),
  every(ms, fn) {
    const id = setInterval(fn, ms);
    return () => clearInterval(id);
  },
};
